var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("navbar.orderImport"),
        visible: _vm.importDialog,
        width: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.importDialog = $event
        },
        close: _vm.handleDialog,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.ruleForm, "label-width": "auto" },
        },
        [
          _c("div", { staticStyle: { margin: "20px 0" } }, [
            _c(
              "span",
              { staticClass: "downModule", on: { click: _vm.downLoadFile } },
              [_vm._v(_vm._s(_vm.$t("orderCenterCont.DownloadTemplate")))]
            ),
            _c("span", { staticStyle: { "font-size": "12px", color: "red" } }, [
              _vm._v(_vm._s(_vm.$t("customerManagements.pleaseUploadLI"))),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "" } },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.triggerFileInput },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("customerManagements.clickUpload")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("input", {
                ref: "referenceUpload",
                staticStyle: { display: "none" },
                attrs: {
                  accept:
                    ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                  type: "file",
                },
                on: {
                  change: function ($event) {
                    return _vm.uploadFile($event)
                  },
                },
              }),
            ],
            2
          ),
          _vm.fileName
            ? _c("div", { staticClass: "downLink" }, [
                _c("div", [_vm._v(_vm._s(_vm.fileName))]),
                _c("div", [
                  _c("i", {
                    staticClass: "el-icon-error",
                    on: { click: _vm.delFile },
                  }),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleDialog } },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.confirmImport },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }